module.exports = __webpack_public_path__ + "static/media/Dass_Client_Page.cfcd3c2c.png";